(() => {
  function forceRightImportant() {
    const el = document.querySelector('#FacetDrawer.mobile-facets__inner');
    if (!el) return;

    // Priorité maximale (inline + !important)
    el.style.setProperty('left', 'auto', 'important');
    el.style.setProperty('right', '0px', 'important');
    el.style.setProperty('margin-left', '0px', 'important');
    el.style.setProperty('transform', 'translateX(0)', 'important');
    el.style.setProperty('width', 'min(420px, 92vw)', 'important');
    el.style.setProperty('max-width', '92vw', 'important');
    el.style.setProperty('box-sizing', 'border-box', 'important');
  }

  function burstFix() {
    const start = performance.now();
    const tick = () => {
      forceRightImportant();
      if (performance.now() - start < 700) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }

  // Quand tu cliques sur "Filtrer" (summary opener)
  document.addEventListener('click', (e) => {
    if (e.target.closest('#Details-FacetDrawer > summary')) {
      // on corrige tout de suite + pendant l’animation
      setTimeout(burstFix, 0);
      setTimeout(burstFix, 40);
    }
  }, true);

  // Quand le <details> s’ouvre
  document.addEventListener('toggle', (e) => {
    if (e.target && e.target.id === 'Details-FacetDrawer') {
      setTimeout(burstFix, 0);
      setTimeout(burstFix, 40);
    }
  }, true);

  console.log('✅ BH drawer right burst fix installé (console). Ouvre Filtrer maintenant.');
})();


document.addEventListener('click', (e) => {
  // Toute icône/bouton qui ferme le drawer (croix en haut)
  const anyClose =
    e.target.closest('#Details-FacetDrawer .mobile-facets__close') ||
    e.target.closest('#Details-FacetDrawer [aria-label="Close"]') ||
    e.target.closest('#Details-FacetDrawer button[name="close"]') ||
    e.target.closest('#Details-FacetDrawer .icon-close') ||
    e.target.closest('#Details-FacetDrawer .modal__close-button');

  if (!anyClose) return;

  const drawer = document.querySelector('#FacetDrawer');
  if (!drawer) return;

  // Page 2 = un sous-menu visible (Dawn met aria-hidden="false" sur le sous-menu actif)
  const activeSubmenu =
    drawer.querySelector('.mobile-facets__submenu[aria-hidden="false"]') ||
    drawer.querySelector('.mobile-facets__details[open] .mobile-facets__submenu');

  if (!activeSubmenu) return; // page 1 => on laisse fermer normalement

  // ✅ On remplace "fermer" par "retour"
  e.preventDefault();
  e.stopPropagation();

  const backBtn =
    activeSubmenu.querySelector('.mobile-facets__close-button') ||
    drawer.querySelector('.mobile-facets__details[open] .mobile-facets__close-button');

  if (backBtn) {
    backBtn.click(); // utilise la logique Dawn (revient page 1)
    return;
  }

  // fallback: fermer le details ouvert
  const openDetails = drawer.querySelector('.mobile-facets__details[open]');
  if (openDetails) openDetails.removeAttribute('open');
}, true);


document.addEventListener('click', (e) => {
  const btn = e.target.closest('#bhFacetPage2Close');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  const drawer = document.querySelector('#FacetDrawer');
  const openDetails = drawer?.querySelector('.mobile-facets__details[open]');
  if (openDetails) {
    openDetails.removeAttribute('open'); // ✅ retour page 1
    return;
  }

  const detailsDrawer = document.querySelector('#Details-FacetDrawer');
  if (detailsDrawer) detailsDrawer.removeAttribute('open');
}, true);

